import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    exportActionSignature,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";
import {
    commentsTab,
    logsTab,
    metadataTab,
    referencesUsedByTab,
    zoneMembersTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import resource from "./resource";

const resourceName = "zone";

/**
 * Permission Zone (RBAC Model G). A zone is a named isolation boundary: a
 * record tagged into a zone (directly, or through its project, bundle or
 * object template) is reachable only through a role permission scoped to that
 * zone. Broad permissions without a zone do not reach it.
 *
 * Duplicate is not offered: a copy would carry no tags and no grants, so it
 * would be an empty zone with a misleading name.
 */
const config: ResourceConfig = {
    label: "Permission zone",
    icon: IconCollection.lockOutline,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: zoneMembersTab.tab.uid,
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${resource.graphql.resourceBody}
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
        `,
    },
    layout: [
        { partial: "pageHeaderForm" },
        { partial: "form" },
        {
            partial: "tabs",
            config: {
                tabs: [
                    zoneMembersTab.tab,
                    logsTab.tab,
                    commentsTab.tab,
                    referencesUsedByTab.tab,
                    metadataTab.tab,
                ],
                content: [
                    zoneMembersTab.content,
                    logsTab.content,
                    commentsTab.content,
                    referencesUsedByTab.content,
                    metadataTab.content,
                ],
            },
        },
    ],
    form: [],
    actions: {
        shown: [],
        hidden: [
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
        ],
    },
};
export default config;
